import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../Common/Loading';
import CustomAlert from '../Common/CustomAlert';
import go_n from '../Common/Images/go_n.gif';
import go_o from '../Common/Images/go_o.gif';
import back_n from '../Common/Images/back_n.gif';
import back_o from '../Common/Images/back_o.gif';
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface MDUserAlert {
    SchoolCode?: string;
    FamilyCode?: string;
    StudentName?: string;
    FirstFamilyName?: string;
    FamilySurname?: string;
    StartedOn?: string;
    StudentSurname?: string;
    GradeYear?: string;
    TeacherName?: string;
    TeacherSurname?: string;
}

interface DropdownOption {
    label: string;
    value: string;
}

const styles = {
    body: {
        margin: '0px',
        fontFamily: 'Trebuchet MS, Arial, Helvetica, sans-serif',
        fontSize: '10pt',
        backgroundColor: '#F0FFFF',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column' as const,
    },

    container: {
        padding: '5px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column' as const,
        overflow: 'hidden',
    },

    filterRow: {
        fontFamily: 'Arial',
        fontSize: '11pt',
        padding: '3px 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap' as const,
        gap: '10px',
        backgroundColor: '#F0FFFF',
        border: '1px solid black',
        marginBottom: '5px'
    },

    headerRow: {
        fontFamily: 'Arial',
        fontSize: '10pt',
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        height: '32px',
        textAlign: 'left' as const,
    },

    headerCell: {
        padding: '8px',
        borderRight: '1px solid #80A0FF',
        borderBottom: '1px solid #80A0FF',
        textAlign: 'left' as const,
        whiteSpace: 'nowrap' as const,
        fontWeight: 'normal' as const,
    },

    row: {
        fontFamily: 'Arial',
        fontSize: '10pt',
        backgroundColor: 'white',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },

    altRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '10pt',
        backgroundColor: '#F4FAFF',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },

    cell: {
        padding: '8px 10px',
        fontSize: '10pt',
        borderRight: '1px solid #80A0FF',
        fontFamily: 'Arial',
        whiteSpace: 'nowrap' as const
    },

    paginationBar: {
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        fontFamily: 'Arial',
        fontSize: '12pt',
        fontWeight: 'bold' as const,
        textAlign: 'center' as const,
        padding: '8px',
        border: 'solid 1px #80A0FF',
        borderTop: 'solid 1px #80A0FF',
        width: '100%',
        boxSizing: 'border-box' as const,
    },

    navLink: {
        textDecoration: 'none',
        color: '#003366',
        margin: '0 5px',
        cursor: 'pointer',
    },

    scrollableDiv: {
        flex: 1,
        overflow: 'auto',
        border: '1px solid #80A0FF',
        width: '100%',
        backgroundColor: 'white',
        textAlign: 'left' as const,
    },

    dropdown: {
        fontFamily: 'Arial',
        fontSize: '10pt',
        border: 'solid 1px gray',
        padding: '0px',
        cursor: 'pointer',
        minWidth: '130px',
        maxWidth: '100%',
        borderRadius: '2px',
    },

    selectedRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '12pt',
        backgroundColor: 'orange',
        color: 'white',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
    },
};

const EL_ListofUsersMDNotCompleted: React.FC = () => {

    const navigate = useNavigate();

    const [isGoHovered, setIsGoHovered] = useState(false);
    const [isBackHovered, setIsBackHovered] = useState(false);

    const [countries, setCountries] = useState<DropdownOption[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [selectedCategory, setSelectedCategory] = useState<string>('FA');

    const [alerts, setAlerts] = useState<MDUserAlert[]>([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [activeCategoryView, setActiveCategoryView] = useState<string>('FA');
    const [loading, setLoading] = useState(false);

    const [alertInfo, setAlertInfo] = useState({
        show: false,
        message: ''
    });

    const [statusMsg, setStatusMsg] = useState<{
        text: string,
        color: string
    } | null>(null);

    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);


    useEffect(() => {

        const fetchDropdowns = async () => {

            setLoading(true);

            try {

                const response = await fetch(
                    `${API_BASE_URL}api/get_family_reg_dropdowns`
                );

                const result = await response.json();

                if (result.status === 'success') {

                    setCountries([
                        {
                            label: '--SELECT--',
                            value: ''
                        },
                        ...result.countries
                    ]);

                    setSelectedCountry('');

                } else {

                    setStatusMsg({
                        text: "Failed to load",
                        color: 'black'
                    });

                    console.log(result.message);
                }

            } catch (error: any) {

                setStatusMsg({
                    text: "Network Error",
                    color: 'red'
                });

                console.error(error);

            } finally {

                setLoading(false);
            }
        };

        fetchDropdowns();

    }, []);


    const fetchData = async () => {

        if (!selectedCountry) {

            setAlertInfo({
                show: true,
                message: 'Please select a country.'
            });

            return;
        }

        setLoading(true);
        setHasSearched(true);
        setStatusMsg(null);

        try {

            const queryParams = new URLSearchParams({
                country: selectedCountry,
                category: selectedCategory
            });

            const response = await fetch(
                `${API_BASE_URL}api/get_md_not_completed_data?${queryParams}`
            );

            const result = await response.json();

            if (result.status === 'success') {

                setAlerts(result.data);
                setActiveCategoryView(result.category);

            } else {

                setStatusMsg({
                    text: "Failed to load data",
                    color: 'red'
                });

                console.log(result.message);
            }

        } catch (error: any) {

            setStatusMsg({
                text: "Network Error",
                color: 'red'
            });

            console.error(error);

        } finally {

            setLoading(false);
        }
    };


    const handleBack = () => {
        navigate('/SysAdmin');
    };


    const currentData = alerts;


    return (
        <div style={styles.body}>

            <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                }}
            >

                <span style={{ marginLeft: "10px" }}>
                    User not completed MD
                </span>

                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/SysAdmin")}
                />

            </div>


            <div style={styles.container}>

                <div style={styles.filterRow}>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            flexWrap: 'wrap'
                        }}
                    >

                        <div>

                            Country&nbsp;:&nbsp;

                            <select
                                style={styles.dropdown}
                                value={selectedCountry}
                                onChange={(e) =>
                                    setSelectedCountry(e.target.value)
                                }
                            >

                                {countries.map(c => (
                                    <option
                                        key={c.value}
                                        value={c.value}
                                    >
                                        {c.label}
                                    </option>
                                ))}

                            </select>

                        </div>


                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >

                            Type of Users&nbsp;:&nbsp;

                            <input
                                type="radio"
                                id="rdoFamily"
                                name="category"
                                value="FA"
                                checked={selectedCategory === 'FA'}
                                onChange={(e) =>
                                    setSelectedCategory(e.target.value)
                                }
                                style={{
                                    marginTop: 0
                                }}
                            />

                            <label
                                htmlFor="rdoFamily"
                                style={{
                                    marginRight: "10px"
                                }}
                            >
                                Family
                            </label>


                            <input
                                type="radio"
                                id="rdoSchool"
                                name="category"
                                value="ST"
                                checked={selectedCategory === 'ST'}
                                onChange={(e) =>
                                    setSelectedCategory(e.target.value)
                                }
                                style={{
                                    marginTop: 0
                                }}
                            />

                            <label htmlFor="rdoSchool">
                                School
                            </label>

                        </div>

                    </div>


                    <div
                        style={{
                            display: 'flex',
                            gap: '15px',
                            alignItems: 'center'
                        }}
                    >

                        <img
                            src={isGoHovered ? go_o : go_n}
                            alt="Go"
                            onClick={fetchData}
                            onMouseEnter={() =>
                                setIsGoHovered(true)
                            }
                            onMouseLeave={() =>
                                setIsGoHovered(false)
                            }
                            style={{
                                cursor: 'pointer'
                            }}
                        />


                        <img
                            src={isBackHovered ? back_o : back_n}
                            alt="Close"
                            onClick={handleBack}
                            onMouseEnter={() =>
                                setIsBackHovered(true)
                            }
                            onMouseLeave={() =>
                                setIsBackHovered(false)
                            }
                            style={{
                                cursor: 'pointer'
                            }}
                        />

                    </div>

                </div>


                {statusMsg && (
                    <div
                        style={{
                            textAlign: 'center',
                            color: statusMsg.color,
                            fontWeight: 'bold',
                            marginBottom: '5px'
                        }}
                    >
                        {statusMsg.text}
                    </div>
                )}


                {hasSearched && (

                    <div style={styles.scrollableDiv}>

                        <table
                            cellPadding={0}
                            cellSpacing={0}
                            style={{
                                borderCollapse: 'collapse',
                                display: 'inline-table',
                                whiteSpace: 'nowrap'
                            }}
                        >

                            <thead
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1
                                }}
                            >

                                <tr>

                                    <th
                                        style={{
                                            ...styles.headerCell,
                                            textAlign: 'center',
                                            color: '#2859ac',
                                            fontWeight: 'bold',
                                            backgroundColor: '#C7DDFD',
                                            fontFamily: 'Arial',
                                            fontSize: '10pt'
                                        }}
                                        colSpan={7}
                                    >
                                        Family Users Maths Doctor Not Completed
                                    </th>

                                </tr>


                                <tr style={styles.headerRow}>

                                    <th style={styles.headerCell}>
                                        #
                                    </th>

                                    {activeCategoryView === 'FA' ? (

                                        <>
                                            <th style={styles.headerCell}>
                                                SchoolCode
                                            </th>

                                            <th style={styles.headerCell}>
                                                FamilyCode
                                            </th>

                                            <th style={styles.headerCell}>
                                                StudentName
                                            </th>

                                            <th style={styles.headerCell}>
                                                FirstFamilyName
                                            </th>

                                            <th style={styles.headerCell}>
                                                FamilySurName
                                            </th>

                                            <th
                                                style={{
                                                    ...styles.headerCell,
                                                    width: "100%"
                                                }}
                                            >
                                                StartedOn
                                            </th>
                                        </>

                                    ) : (

                                        <>
                                            <th style={styles.headerCell}>
                                                SchoolCode
                                            </th>

                                            <th style={styles.headerCell}>
                                                StudentName
                                            </th>

                                            <th style={styles.headerCell}>
                                                StudentSurName
                                            </th>

                                            <th style={styles.headerCell}>
                                                GradeYear
                                            </th>

                                            <th style={styles.headerCell}>
                                                TeacherName
                                            </th>

                                            <th
                                                style={{
                                                    ...styles.headerCell,
                                                    width: "100%"
                                                }}
                                            >
                                                TeacherSurName
                                            </th>
                                        </>

                                    )}

                                </tr>

                            </thead>


                            <tbody
                                style={{
                                    height:
                                        currentData.length === 0
                                            ? '100%'
                                            : 'auto'
                                }}
                            >

                                {loading ? (

                                    <tr>

                                        <td
                                            colSpan={8}
                                            style={{
                                                padding: '20px',
                                                textAlign: 'center',
                                                verticalAlign: 'top'
                                            }}
                                        >
                                            <Loading />
                                        </td>

                                    </tr>

                                ) : (

                                    currentData.map((row, index) => {

                                        const isSelected =
                                            selectedRowIndex === index;

                                        let rowStyle =
                                            index % 2 === 0
                                                ? styles.altRow
                                                : styles.row;

                                        if (isSelected) {
                                            rowStyle = styles.selectedRow;
                                        }

                                        const serialNumber =
                                            index + 1;


                                        return (

                                            <tr
                                                key={index}
                                                style={rowStyle}
                                                onClick={() =>
                                                    setSelectedRowIndex(index)
                                                }
                                            >

                                                <td
                                                    style={{
                                                        ...styles.cell,
                                                        width: '40px',
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    {serialNumber}
                                                </td>


                                                {activeCategoryView === 'FA' ? (

                                                    <>

                                                        <td style={styles.cell}>
                                                            {row.SchoolCode}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.FamilyCode}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.StudentName}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.FirstFamilyName}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.FamilySurname}
                                                        </td>

                                                        <td
                                                            style={{
                                                                ...styles.cell,
                                                                width: "100%"
                                                            }}
                                                        >
                                                            {row.StartedOn}
                                                        </td>

                                                    </>

                                                ) : (

                                                    <>

                                                        <td style={styles.cell}>
                                                            {row.SchoolCode}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.StudentName}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.StudentSurname}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.GradeYear}
                                                        </td>

                                                        <td style={styles.cell}>
                                                            {row.TeacherName}
                                                        </td>

                                                        <td
                                                            style={{
                                                                ...styles.cell,
                                                                width: "100%"
                                                            }}
                                                        >
                                                            {row.TeacherSurname}
                                                        </td>

                                                    </>

                                                )}

                                            </tr>
                                        );
                                    })

                                )}


                                {currentData.length === 0 && !loading && (

                                    <tr>

                                        <td
                                            colSpan={8}
                                            style={{
                                                padding: '10px',
                                                textAlign: 'center',
                                                color: '#555',
                                                height: '100%',
                                                backgroundColor: '#F0FFFF'
                                            }}
                                        >
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                )}

            </div>


            {alertInfo.show && (

                <CustomAlert
                    message={alertInfo.message}
                    onClose={() =>
                        setAlertInfo({
                            ...alertInfo,
                            show: false
                        })
                    }
                />

            )}

        </div>
    );
};

export default EL_ListofUsersMDNotCompleted;